export default {
    CustomerList: {
        ChooseCustomer: 'Müşteri Seçimi',
    },

    Customer: {
        SafesOnline: 'Çevrimiçi Kasalar',
        CurrentBalance: 'Anlık Bakiye',
        DailySales: 'Günlük Satışlar',
        ActiveWarnings: 'Aktif Uyarılar',
        Of: 'OF',
        In: 'IN',
        Branches: 'ŞUBELER'
    },

    Branch: {
        ExportTransactions: "İşlemleri Gönder",
        ManageOperators: "Operatörler Yönetimi",
        ShowOnMap: "Haritada Göster",
        CurrentBalance: "Anlık Bakiye",
        DailySales: 'Günlük Satışlar',
        MainCurrency: 'Para Birimleri',
        TransactionDays: 'İşlem Günleri'
    },

    BranchList: {
        Name: 'İsim',
        Status: 'Durum',
        BalanceAmount: 'Bakiye Tutarı',
        BalanceCurrency: 'Para Birimi Bakiyesi',
        LastBalance: 'Son Bakiye',
        Branches: 'Şubeler',
    },

    BranchListFilter: {
        Branches: 'Şubeler',
        SearchCriteria: 'Arama Kriteri',
    },


    Chart: {
        Sales: 'Satışlar',
        Pickup: 'Toplama',
        Balance: 'Bakiye',
        Difference: 'Fark',
        Confirmed: 'Onaylanan',
        SalesBalancesAndPickups: 'Satışlar, Bakiyeler & Günsonları',
        NoDataAvailable: 'Kullanılabilir Veri Yok',
        SafebagBalance: 'Çanta bakiyesi',
        RecyclableBalance: 'Kullanılabilir Bakiye',
        ManualDepositBalance: 'Manuel Zarflı Yatırma Bakiyesi',
        OverflowBalance: 'Kapasite Fazlası Bakiye'
    },

    ChartDenominations: {
        Deposited: 'Yatırılan',
        Recyclable: 'Geri Dönüşümlü',
        Denominations: 'Banknot Adetleri',
        NoDataAvailable: 'Kullanılabilir Veri Yok'
    },

    ChartTransactionDay: {
        ProcessedSales: 'Yapılan Satışlar',
        UnprocessedSales: 'Tamamlanmamış Satışlar',
        SalesOut: 'Dış Satışlar',
        SalesPerHour: 'Saat Başı Satışlar'
    },

    CustomerHeader: {
        ShowOnMap: 'Haritada Göster',
        Branches: 'Şubeler',
        Branch: 'Şube',
        ExportTransactions: 'İşlemleri Gönder',
    },

    DeviceStatus: {
        AllOk: 'Hepsi Tamam',
    },

    DeviceStatusList: {
        Safes: 'Kasalar',
    },

    ExportForm: {
        ExportTransactions: 'İşlemleri Gönder',
        Cancel: 'İptal',
        Export: 'Gönder',
        FromDate: 'Başlangıç Tarihi',
        Time: 'Zaman',
        EndDate: 'Bitiş Tarihi'
    },

    ForgotPasswordForm: {
        ForgotHeader: 'Şifrenizi mi unuttunuz?',
        ForgotText: 'Lütfen e-posta adresinizi giriniz.Yönergeleri içeren bir e-posta alacaksınız.',
        LoginLink: 'Tekrar giriş için',
        EmailAddress: 'E-posta adresi',
        Submit: 'E-posta gönder',
        ErrorMessage: 'Sunucuya istek gönderemedik.'
    },

    LoginPage: {
        LoginHeader: 'Hoş Geldiniz',
        LoginText: 'E-posta ve şifrenizi giriniz.',
        LoginForgot: 'Şifrenizi mi unuttunuz?',
        Username: 'E-POSTA',
        Password: 'ŞİFRE',
        Login: 'Giriş'
    },

    ResetPasswordPage: {
        ResetHeader: 'Şifre sıfırlama',
        ResetText: 'Yeni şifrenizi giriniz.'
    },

    Drawer: {
        Dashboard: 'Kontrol Paneli',
        SwitchCustomer: 'Müşteri Değiştir',
        MyProfile: 'Profilim',
        Logout: 'Çıkış'
    },

    OperatorForm: {
        UserId: 'Kullanıcı Kimliği',
        FirstName: 'Ad',
        LastName: 'Soyad',
        Pin: 'Pin',
        Save: 'Kaydet',
        Delete: 'Sil',
        Operator: 'Operatör'
    },

    OperatorList: {
        AddOperator: 'Operatör Ekle',
        Operators: 'Operatörler',
        Name: 'İsim'
    },

    Profile: {
        Profile: 'Profil',
        Name: 'İsim',
        Language: 'Dil',
        Password: 'Şifre',
        ConfirmPassword: 'Şifreyi Onaylayın',
        Update: 'Güncelleme'
    },

    ResetPasswordForm: {
        NewPassword: 'Yeni Şifre',
        ConfirmPassword: 'Şifreyi Onaylayın',
        Submit: 'Gönder'
    },

    InviteUserForm: {
        InviteHeader: 'Kullanıcı Davet Et',
        InviteText: 'Profil bilgilerini doldurup giriş için kaydedin.',
        Name: 'Ad',
        Language: 'İsim',
        NewPassword: 'Yeni Şifre',
        ConfirmPassword: 'Şifreyi Onayla',
        Submit: 'Kaydet'
    },

    TransactionList: {
        Type: 'Yazın',
        Operator: 'Operatör',
        When: 'Ne Zaman?',
        Amount: 'Tutar',
        Currency: 'Para Birimi',
        Transactions: 'İşlemler',
        Device: 'Cihaz',
        SalesDay: 'Satış Günü',
        HoverDeposit: 'Satışlar',
        HoverSalesIn: 'Satışlar',
        HoverSalesOut: 'Sales out',
        HoverManualDeposit: 'Manuel Yatırma',
        HoverCollection: 'Toplama',
        HoverCollectionNotes: 'Banknot Toplama',
        HoverCollectionCoins: 'Madeni Toplama',
        HoverCollectionEnvelope: 'Toplanan Manuel Yatırmalar',
        HoverCollectionOK: 'Onaylanmış Toplama',
        HoverCollectionNotesOK: 'Onaylanmış Banknot Toplamaları',
        HoverCollectionCoinsOK: 'Onaylanmış Madeni Toplamaları',
        HoverCollectionEnvelopeOK: 'Onaylanmış Manuel Yatırma Toplamaları',
        HoverCollectionNOK: 'Fark Toplama',
        HoverCollectionNotesNOK: 'Banknot Farkı Toplamaları',
        HoverCollectionCoinsNOK: 'Madeni Farkı Toplamaları',
        HoverCollectionEnvelopeNOK: 'Manuel Yatırma Farkı Toplamaları',
        HoverDrain: 'Çıkarma',
        HoverRefill: 'Doldurma',
        HoverExchange: 'Çevirme',
        HoverExchangeIn: 'Exchange in',
        HoverExchangeOut: 'Exchange out',
        HoverCounterfeit: 'Geçersiz',
        HoverInternal: 'Dahili İşlem',
        HoverNOP: 'Operasyon Yok'
    },

    TransactionDayList: {
        Date: "Tarih",
        Sales: "Satışlar",
        Pickup: "Toplama",
        Balance: "Bakiye",
        TransactionDays: "İşlem Günleri"
    },

    TransactionDay: {
        Date: "Tarih",
        Sales: "Satışlar",
        Pickup: "Toplama",
        Balance: "Bakiye",
        TransactionDays: "İşlem Günleri",
        ExportTransactions: "İşlemler"
    },

    TransactionDatePicker: {
        Date: 'Tarih'
    }
};


// WEBPACK FOOTER //
// ./src/lib/i18n/tr.js